<main class="auth-shell flex min-h-screen items-center justify-center px-4 py-10">
  <nz-card class="w-full max-w-md" [nzTitle]="'resetPsd.title' | translate">
    @if (errorMessage) {
      <nz-alert class="mb-4" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>
    }

    @if (token) {
      <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="submit()">
        <app-psd-fields [form]="form"/>

        <div class="mt-6 flex flex-col gap-3">
          <button
            class="w-full"
            nz-button
            nzType="primary"
            type="submit"
            [nzLoading]="isSubmitting"
            [disabled]="form.invalid"
          >
            {{ 'resetPsd.submit' | translate }}
          </button>
          <a class="w-full" nz-button nzType="default" routerLink="/login">{{ 'resetPsd.backToLogin' | translate }}</a>
        </div>
      </form>
    } @else {
      <div class="mt-4">
        <a class="w-full" nz-button nzType="primary" routerLink="/login">{{ 'resetPsd.returnToLogin' | translate }}</a>
      </div>
    }
  </nz-card>
</main>
